import ZTable, { IColumnType, ITableRef } from '@/components/ZTable';
import { ModalWidth, formatDisplayFullDate } from '@/config';
import { Modal } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { BookingPagingDto, TicketPagingDto } from '@/__generated';

const columns: IColumnType<any>[] = [
  {
    title: 'ticketBooking_BookingRefNo',
    dataIndex: 'bookingRefNo',
    ellipsis: true,
    sorter: true,
    width: 180,
  },
  {
    title: 'ticketBooking_TicketRefNo',
    dataIndex: 'ticketRefNo',
    sorter: true,
    ellipsis: true,
    width: 200,
  },
  {
    title: 'ticketBooking_Passenger',
    dataIndex: 'passengerType',
    ellipsis: true,
    width: 180,
  },
  {
    title: 'Passenger name and phone number',
    dataIndex: 'passengerType',
    ellipsis: true,
    render: (_, v) => [v.passengerFullName, v.passengerPhoneCode, v.passengerPhoneNumber].filter(x => x).join(' '),
  },
  {
    title: 'seatModelsPage_SeatName',
    dataIndex: 'seatName',
    ellipsis: true,
    width: 100,
  },
  {
    title: 'ticketBooking_BookingDate',
    dataIndex: 'createdOn',
    width: 170,
    ellipsis: true,
    render: v => (v ? formatDisplayFullDate(v) : ''),
    sorter: true,
  },
];

type Props = {
  booking: BookingPagingDto;

  onClose: () => void;
};

export default function TicketsModal({ booking, onClose }: Props) {
  const zTb = React.useRef<ITableRef>();
  const { t } = useTranslation();

  return (
    <Modal
      width={ModalWidth.extraLarge}
      title={t('bookingPage_Tickets')}
      onOk={onClose}
      okText={t('Close')}
      cancelButtonProps={{ style: { display: 'none' } }}
      open={true}
      onCancel={onClose}
    >
      {booking.bookingId ? (
        <ZTable<TicketPagingDto>
          columns={columns}
          primaryKey="id"
          tableRef={zTb}
          url="/bookings/sell-on-the-go/get-tickets"
          defaultFilter={{ bookingId: booking.bookingId }}
          bordered
          order_by_asc={true}
          allowEdit={false}
          allowDelete={false}
          searchBtnAlignLeft
          actionColumnWidth={80}
        />
      ) : null}
    </Modal>
  );
}
